import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Checkmark as CheckMarkIcon, Uncheckmark as UncheckmarkIcon, ArrowDown as ArrowDownIcon } from '../../icons';

import { SPECIAL_OPTION, ViewerAttributeInterface, ViewerAttributeInputInterface } from '../../core';

import styled from './MenuChoiceAttributeTitle.module.scss';
import CheckboxIcon from '../CheckboxIcon';
import { textHelpHtml } from '../../core/utils/functions';

export interface MenuChoiceAttributeTitleProps {
  isActive: boolean;
  attribute: ViewerAttributeInterface;
  select: (attr: ViewerAttributeInterface) => void;
}

const MenuChoiceAttributeTitle: React.FC<MenuChoiceAttributeTitleProps> = (props) => {
  const [t] = useTranslation();

  const hasOptionsSelected = (): boolean => !!props.attribute?.options?.some((opt) => !!opt.selected);

  const hasOptionsNotSetSelected = (): boolean => !!props.attribute?.options?.some((opt) => !!opt.selected && opt.id === SPECIAL_OPTION.NOT_SET);

  /* const renderSelectionIcon = () =>
    hasOptionsNotSetSelected() ? <UncheckmarkIcon data-testid='uncheck-icon' /> : <CheckMarkIcon data-testid='check-icon' />; */
  const renderSelectionIcon = () => <CheckboxIcon checked={!hasOptionsNotSetSelected()} />;

  const [stateActive, setStateActive] = React.useState(false);

  const onOptionSelect = (e: any) => {
    const target = e.target;
    if (!target.href) {
      props.select(props.attribute);
      setStateActive(!stateActive);
    }
  };

  const name = (props.attribute as any).minAmount
    ? t(props.attribute.id, {
        value: (props.attribute as any).minAmount,
      })
    : t(props.attribute.id);

  return (
    <div
      className={classnames(styled.ff_menu_choice_attribute_title, {
        [styled.ff_menu_choice_attribute_title__active]: stateActive,
      })}
      data-testid='ff-menu-choice-attribute-title'
      onClick={onOptionSelect}
    >
      <div className={styled.ff_menu_choice_attribute_selection_icon}>{renderSelectionIcon()}</div>
      <div dangerouslySetInnerHTML={textHelpHtml(name)} className={styled.ff_menu_choice_attribute_description}></div>
      {hasOptionsSelected() && (
        <div className={styled.ff_menu_choice_attribute_selected_option}>
          {props.attribute.options
            .filter((opt) => opt.selected)
            .map((opt) => t(opt.id))
            .join(', ')}
        </div>
      )}
      <div className={styled.ff_menu_choice_attribute_state_icon}>
        <ArrowDownIcon />
      </div>
    </div>
  );
};

export default MenuChoiceAttributeTitle;
